export default __webpack_public_path__ + "static/media/Brow_4_C5.04e8bc6a.svg";